import { ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import type { CoursesListGateway } from '../../interfaces/course-list.interface';

@injectable()
export class GetCoursePageLinkCollaboration
  implements ICollaboration<string, string>
{
  constructor(
    @inject('CoursesListGateway')
    private readonly coursesListGateway: CoursesListGateway,
  ) {}

  async run(courseName?: string): Promise<string> {
    const basePath = process.env.REACT_APP_DESCOMPLICA_BASE_PATH;
    const fallbackUrl = `${basePath}/faculdade/`;

    if (!courseName) return fallbackUrl;

    try {
      const courses = await this.coursesListGateway.getCoursesList();

      const course = courses.find((course) => {
        return course.cleanTitle
          .toLowerCase()
          .includes(courseName.toLowerCase());
      });

      if (!course) return fallbackUrl;
      return `${basePath}${course.link}`;
    } catch (error: any) {
      return fallbackUrl;
    }
  }
}
